import React from "react";
import "./styles.css";
import { useTranslation } from "react-i18next";

function PartnersAndTeams() {
  const { t } = useTranslation("lifeAtBitsclan");
  const partnersAndTeam = t("partnersAndTeam", { returnObjects: true });

  const icons = [
    {
      icon: "/images/partners-icons/google-icon.png",
      height: 30,
      width: 100,
    },
    {
      icon: "/images/partners-icons/aws-icon.png",
      height: 30,
      width: 60,
    },
    {
      icon: "/images/partners-icons/azure-icon.png",
      height: 40,
      width: 80,
    },
    {
      icon: "/images/partners-icons/cisco-icon.png",
      height: 30,
      width: 70,
    },
    {
      icon: "/images/partners-icons/dell-icon.png",
      height: 30,
      width: 90,
    },
    {
      icon: "/images/partners-icons/ms-icon.png",
      height: 30,
      width: 100,
    },
    {
      icon: "/images/partners-icons/kh-icon.png",
      height: 30,
      width: 100,
    },
  ];
  return (
    <div className="become-a-partner-main-box">
      <div className="container position-relative">
        <div className="row">
          <div className="col-md-6 partners-headings-wrapper">
            <p className="partners-heading">{partnersAndTeam?.heading}</p>
            <p className="partners-sub-heading">{partnersAndTeam?.subHeading}</p>
          </div>
          <div className="col-md-6 partners-des-wrapper">
            <p className="description-text">{partnersAndTeam?.description}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="partners-logo-wrappers">
              {icons.map((item, index) => (
                <div className="partners-logo">
                  <img
                    alt=""
                    src={item?.icon}
                    height={item?.height}
                    width={item?.width}
                  />
                </div>
              ))}
            </div>
          </div>
          {/* <div className="col-md-6 partners-avatar-btn-wrapper">
          <div className="partners-btn-wrapper">
            <p>{partnersAndTeam?.btnHeading}</p>

            <button className="partners-btn">
              <p>{partnersAndTeam?.btnText}</p>{" "}
              <i
                className={`fa-solid ${
                  document.dir === "rtl"
                    ? "fa-arrow-left-long"
                    : "fa-arrow-right-long"
                }`}
              ></i>
            </button>
          </div>
        </div> */}
        </div>

        <img
          style={{ position: "absolute", bottom: "0rem", insetInlineEnd: "0rem" }}
          src="/images/life-at-bitsclan/mouse.svg"
          alt="CEO Image"
          className="mouse-logo-image"
        />
      </div>
    </div>
  );
}

export default PartnersAndTeams;
